export interface IBillcheckStarted {
  status: LEGACY_BILLCHECK_STATUS.STARTED;
  premium: boolean;
  minekoIframeUrl: string;
  minekoTicketId?: string;
  updatedAt?: number;
}

export interface IBillcheckOrdered {
  status: LEGACY_BILLCHECK_STATUS.ORDERED;
  premium: boolean;
  minekoIframeUrl: string;
  minekoTicketId: string;
  updatedAt: number;
  orderCartId: string;
}

export interface IBillcheckSubmitted {
  status: LEGACY_BILLCHECK_STATUS.SUBMITTED;
  premium?: boolean;
  minekoIframeUrl?: string;
  minekoTicketId: string;
  updatedAt?: number;
}

export interface IBillcheckPending extends Omit<IBillcheckSubmitted, 'status'> {
  status: LEGACY_BILLCHECK_STATUS.PENDING;
}

export interface IBillcheckDone extends Omit<IBillcheckSubmitted, 'status'> {
  status: LEGACY_BILLCHECK_STATUS.DONE;
}

export interface IBillcheckActionRequired extends Omit<IBillcheckSubmitted, 'status'> {
  status: LEGACY_BILLCHECK_STATUS.ACTION_REQUIRED;
}

export type ILegacyBillcheckStatus =
  | IBillcheckStarted
  | IBillcheckOrdered
  | IBillcheckSubmitted
  | IBillcheckPending
  | IBillcheckDone
  | IBillcheckActionRequired;

export enum LEGACY_BILLCHECK_STATUS {
  STARTED = 'STARTED',
  ORDERED = 'ORDERED',
  SUBMITTED = 'SUBMITTED',
  PENDING = 'PENDING',
  DONE = 'DONE',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
}

export interface ILegacyBillchecksStatusRes {
  billChecks: ILegacyBillcheckStatus[];
  newFlowAvailable: boolean;
  plusProduct: boolean;
}

export type LegacyBillcheckState = ILegacyBillchecksStatusRes;
